import { ComponentTagMappings } from "binder";
import { ButtonViewModel } from "./button/button-viewModel";
import { CheckboxViewModel } from "./checkbox/checkbox-viewModel";
import { ComboBoxViewModel } from "./comboBox2/comboBox-viewModel";
import { GridViewModel } from "./containers/grid/grid-viewModel";
import { ContentViewModel } from "./content/content-viewModel";
import { DateSelectorViewModel } from "./dateSelector/dateSelector-viewModel";
import { DragDropContainerViewModel } from "./dragDropContainer/dragDropContainer-viewModel";
import { ExactTimeViewModel } from "./exactTime/exactTime-viewModel";
import { ClientFilteringTable } from "./extable/clientFilteringTable";
import { BooleanColumnViewModel, DateColumnViewModel, EnumColumnViewModel, NumericColumnViewModel, StringColumnViewModel } from "./extable/column/columnTypes/columnTypes-viewModel";
import { ExTableViewModel } from "./extable/exTable-viewModel";
import { ServerFilteringTable } from "./extable/serverFilteringTable";
import { FileSelectorViewModel } from "./fileSelector/fileSelector-viewModel";
import { HorizontalLineViewModel } from "./horizontalLine/horizontalLine-viewModel";
import { LinearChartViewModel } from "./linearChart/linearChart-viewModel";
import { ListViewModel } from "./list/list-viewModel";
import { LoadingViewModel } from "./loading/loading-viewModel";
import { MultiLineTextInputViewModel } from "./multiLinetextInput/multiLineTextInput-viewModel";
import { MultiSelectComboBoxViewModel } from "./multiSelectComboBox/multiSelectComboBox-viewModel";
import { OverlayViewModel } from "./overlay/overlay-viewModel";
import { PictureCaptureViewModel } from "./pictureCapture/pictureCapture-viewModel";
import { PieChartViewModel } from "./pieChart/pieChart-viewModel";
import { PopupViewModel } from "./popup/popup-viewModel";
import { ScrollViewerViewModel } from "./scrollViewer/scrollViewer-viewModel";
import { SidebarViewModel } from "./sidebar/sidebar-viewModel";
import { SplittedDateSelectorViewModel } from "./splittedDateSelector/splittedDateSelector-viewModel";
import { SwitchCheckBoxViewModel } from "./switchCheckbox/switchCheckBox-viewModel";
import { TabViewModel } from "./tab/tab-viewModel";
import { TableViewModel } from "./table/table-viewModel";
import { TextInputViewModel } from "./textInput/textInput-viewModel";
import { TimeSelectorViewModel } from "./timeSelector/timeSelector-viewModel";
import { ToggleButtonViewModel } from "./toggleButton/toggleButton-viewModel";
import { TogglePopupViewModel } from "./togglePopup/togglePopup-viewModel";
import { TooltipViewModel } from "./tooltip/tooltip-viewModel";
import { TreeViewModel } from "./tree/tree-viewModel";

export class ComponentRegisterator{

    public static registerServiceWorker(serviceWorkerAddress:string):void{
        if(window.navigator.serviceWorker)
            window.navigator.serviceWorker.register(serviceWorkerAddress)
    }
    public static register():void{
        require('./components.less')
        ComponentTagMappings.register("grid",p=>new GridViewModel(p));
        ComponentTagMappings.register("checkbox",p=>new CheckboxViewModel(p));
        ComponentTagMappings.register("check",p=>new CheckboxViewModel(p));
        ComponentTagMappings.register("switch",p=>new SwitchCheckBoxViewModel(p));
        ComponentTagMappings.register("input",p=>new TextInputViewModel(p));
        ComponentTagMappings.register("text",p=>new TextInputViewModel(p));
        ComponentTagMappings.register("multilineinput",p=>new MultiLineTextInputViewModel(p));
        ComponentTagMappings.register("button",p=>new ButtonViewModel(p));
        ComponentTagMappings.register("date",p=>new DateSelectorViewModel(p));
        ComponentTagMappings.register("splitteddate",p=>new SplittedDateSelectorViewModel(p));
        ComponentTagMappings.register("loading",p=>new LoadingViewModel(p));
        ComponentTagMappings.register("tab",p=>new TabViewModel(p));
        ComponentTagMappings.register("list",p=>new ListViewModel(p));
        ComponentTagMappings.register("overlay",p=>new OverlayViewModel(p));
        ComponentTagMappings.register("scroll",p=>new ScrollViewerViewModel(p));
        ComponentTagMappings.register("table",p=>new TableViewModel(p));
        
        ComponentTagMappings.register("clientfiltertable",p=>new ClientFilteringTable(p));
        ComponentTagMappings.register("serverfiltertable",p=>new ServerFilteringTable(p));
        ComponentTagMappings.register("stringcolumn",p=>new StringColumnViewModel(p));
        ComponentTagMappings.register("numericcolumn",p=>new NumericColumnViewModel(p));
        ComponentTagMappings.register("numbercolumn",p=>new NumericColumnViewModel(p));
        ComponentTagMappings.register("enumcolumn",p=>new EnumColumnViewModel(p));
        ComponentTagMappings.register("boolcolumn",p=>new BooleanColumnViewModel(p));
        ComponentTagMappings.register("booleancolumn",p=>new BooleanColumnViewModel(p));
        ComponentTagMappings.register("datecolumn",p=>new DateColumnViewModel(p));


        ComponentTagMappings.register("combo",p=>new ComboBoxViewModel(p));
        ComponentTagMappings.register("time",p=>new TimeSelectorViewModel(p));
        ComponentTagMappings.register("exacttime",p=>new ExactTimeViewModel(p));
        ComponentTagMappings.register("tree",p=>new TreeViewModel(p));
        ComponentTagMappings.register("dragdrop",p=>new DragDropContainerViewModel(p));
        ComponentTagMappings.register("content",p=>new ContentViewModel(p));
        ComponentTagMappings.register("capturepic",p=>new PictureCaptureViewModel(p));
        ComponentTagMappings.register("file",p=>new FileSelectorViewModel(p));
        ComponentTagMappings.register("popup",p=>new PopupViewModel(p));
        ComponentTagMappings.register("tooltip",p=>new TooltipViewModel(p));
        ComponentTagMappings.register("togglebutton",p=>new ToggleButtonViewModel(p));
        ComponentTagMappings.register("togglepopup",p=>new TogglePopupViewModel(p));
        ComponentTagMappings.register("hr",p=>new HorizontalLineViewModel(p));
        ComponentTagMappings.register("multicombo",p=>new MultiSelectComboBoxViewModel(p));
        ComponentTagMappings.register("sidebar",p=>new SidebarViewModel(p));
        ComponentTagMappings.register("pie",p=>new PieChartViewModel(p));
        ComponentTagMappings.register("linechart",p=>new LinearChartViewModel(p));
    }
} 